import { Admin } from '.';

type ProfileProperty = {
  caption: string;
  property: keyof typeof Admin.properties | 'profileName';
};

const profile: ProfileProperty[] = [
  { caption: 'Name', property: 'profileName' },
  { caption: 'LTV', property: 'adminProfileLtv' },
  { caption: 'Created at', property: 'adminProfileCreatedAt' },
  { caption: 'Updated at', property: 'adminProfileUpdatedAt' },
  { caption: 'Gems (free)', property: 'adminProfileFreeGems' },
  { caption: 'Gems (paid)', property: 'adminProfilePaidGems' },
  { caption: 'B-Coins', property: 'adminProfilePoints' },
  { caption: 'Last purchase name', property: 'adminProfileLastPurchaseName' },
  { caption: 'Last purchase date', property: 'adminProfileLastPurchaseDate' },
];

const adminMessageGroups: {
  [name: string]: (keyof typeof Admin.messages)[];
} = {
  Gems: ['admin_addFreeGems', 'admin_removeGems', 'admin_setFreeGems'],
  Coins: ['admin_addCoins', 'admin_removeCoins', 'admin_setCoins'],
};

export default {
  profile,
  adminMessageGroups,
};
